import Router, { Route } from 'preact-router';
import { useState } from 'preact/hooks';
import Home from './pages/Home';
import Create from './pages/Create';
import Pricing from './pages/Pricing';
import { Header } from './components/Header';
import './styles/variables.css';
import './index.css';

export function App() {
  const [currentPath, setCurrentPath] = useState('/');

  return (
    <div>
      <Header currentPath={currentPath} />
      <Router onChange={(e) => setCurrentPath(e.url ?? '/')}>
        <Route path="/" component={Home} />
        <Route path="/create" component={Create} />
        <Route path="/pricing" component={Pricing} />
      </Router>
    </div>
  );
}
